import firebase from '../../constants/firebase';

const db = firebase.firestore()

export const addLocation = async (locationInfo) => {
    const docRef = db.collection('locations').doc(locationInfo.docRef)
    docRef.set(locationInfo, { merge: true })
}